import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const CloudUpload = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 19.2501V11.7501M12 11.7501L14.5 14.2501M12 11.7501L9.5 14.2501M15 19.2501H18.125C20.4032 19.2501 22.25 17.4032 22.25 15.1251C22.25 12.8469 20.4032 11.0001 18.125 11.0001C18.0814 11.0001 18.038 11.0007 17.9948 11.0021C17.9983 10.9185 18 10.8345 18 10.7501C18 7.43635 15.3137 4.75006 12 4.75006C9.3716 4.75006 7.13793 6.44015 6.32647 8.79286C3.74507 9.12346 1.75 11.3288 1.75 14.0001C1.75 16.8996 4.10051 19.2501 7 19.2501H9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M5.77996 8.12433C6.80396 5.70159 9.20241 4.00006 12 4.00006C15.5725 4.00006 18.4969 6.77548 18.7344 10.2878C21.1392 10.5877 23 12.6391 23 15.1251C23 17.8174 20.8174 20.0001 18.125 20.0001H12.75V13.5607L13.9697 14.7804C14.2626 15.0733 14.7374 15.0733 15.0303 14.7804C15.3232 14.4875 15.3232 14.0126 15.0303 13.7197L12.5303 11.2197C12.2374 10.9268 11.7626 10.9268 11.4697 11.2197L8.96967 13.7197C8.67678 14.0126 8.67678 14.4875 8.96967 14.7804C9.26256 15.0733 9.73744 15.0733 10.0303 14.7804L11.25 13.5607V20.0001H7C3.68629 20.0001 1 17.3138 1 14.0001C1 11.1041 3.05102 8.68831 5.77996 8.12433Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
